import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().min(1),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
});

export type AppConfig = z.infer<typeof envSchema>;

export function readConfig(): AppConfig | null {
  const parsed = envSchema.safeParse({
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  });

  return parsed.success ? parsed.data : null;
}
